import { render, staticRenderFns } from "./language-selection.vue?vue&type=template&id=61a94948&scoped=true&"
import script from "./language-selection.vue?vue&type=script&lang=js&"
export * from "./language-selection.vue?vue&type=script&lang=js&"
import style0 from "./language-selection.vue?vue&type=style&index=0&id=61a94948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a94948",
  null
  
)

export default component.exports